module.exports = __webpack_public_path__ + "static/apple_store_badge-fee2deaa930eb8e2ebcea4200c552b18.svg";